import './activationguide.css';
import React, { Component } from 'react';
import { getCustomerState, focusOnHeading, getCurrentRouteName, scrollToBody, getAbleSpriteSheet } from '../../adapters/utils';
import { getUiState } from '../../adapters/store-utils';
import { addDataLayerEventInfo, addToTransactionLayer } from '../../adapters/analytics-utils';
import boostAppImage from '../../assets/img/image-boost-app.jpg';
import simCard from '../../assets/img/svg/boost-sim.svg';
import boostProfile from '../../assets/img/svg/boost-profile.svg';
import boostAppIcon from '../../assets/img/boost-app-icon.jpg';
import OfferCard from './../../routes/review-details/components/offerCard';
import store from '../../store';
import { updateStepperCustomData } from '../../components/Progress/module';
import { GET_THE_APP, DOWNLOAD_APP_IOS, DOWNLOAD_APP_ANDROID, SIGN_IN } from '../../adapters/constants';
import AutoRechargeEnabledCard from './AutoRechargeEnabled/autoRechargeEnabled';
import SpinningButton from '../../components/SpinningButton/SpinningButton';
import GlobalBanner from '../../common/components/globalBanner/globalBanner';
import { ActionButton, Clock56, Divider, Icon, MessageSection, Picto, Spacing, Success104, TextStyle } from '@able/react';
import ACTIVATION_GUIDE_CONSTANTS from './constants';

const step2image = require('../../assets/img/Step2-image.jpg');
const step3image = require('../../assets/img/Step3-image.jpg');
const ableSpriteSheet = getAbleSpriteSheet();

class ActivationGuide extends Component {
    componentWillMount() {
        this.setState({
            showSurvey: false
        });
    }

    componentDidMount() {
        const state = store.getState();
        const {
            customer: { data: { hasTdiLogin = true } = {} } = {},
            esimData: { hasCompletedEsimProfileDownload }
        } = state.app.appData;
        const {
            activationDataDetails: { customerInteractionId }
        } = state.app.appData.activationData;
        if (!hasTdiLogin) {
            addDataLayerEventInfo('impression', 'createTDI');
        } else {
            addDataLayerEventInfo('impression', 'existingTDI');
        }
        const skipRecharge = this.props.appData.skipRecharge;
        if (skipRecharge === false) {
            addDataLayerEventInfo('prepaidRecharge', '', '', '');
        }
        const pageNameArr = getCurrentRouteName();
        document.title = pageNameArr.pageName;
        focusOnHeading();
        scrollToBody('body');
        // const { rechargeAmount, offerCode } = getCustomerState();
        // const data = {
        //     productID: offerCode,
        //     price: rechargeAmount,
        //     quantity: 1
        // };
        addToTransactionLayer(customerInteractionId);
        const { isEsimActivation = false } = getUiState();
        const { downloadEsimProfile } = this.props.actions;
        isEsimActivation && !hasCompletedEsimProfileDownload && downloadEsimProfile();
        const stepperData = {
            totalSteps: isEsimActivation ? 7 : 6,
            currentStep: isEsimActivation ? 7 : 5,
            isLastStepCompleted: true
        };
        store.dispatch(updateStepperCustomData(stepperData));
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', () => {
            window.history.pushState(null, document.title, window.location.href);
        });
    }

    render() {
        const { selectedActivationFlow = '', loggedIn = false, isEsimActivation = false } = getUiState();
        const isPortingFlow = selectedActivationFlow === 'portNumber';
        const skipRecharge = this.props.appData.skipRecharge;
        const hasEsimProfileError = this.props.appData.esimData.hasEsimProfileError;
        const isProcessingProfile = this.props.appData.esimData.isProcessingProfile;
        // Get Service details
        const state = store.getState();
        let actualAmount, priceBeforeDiscount;
        // hasTdiLogin is true when Unauthenticated customer is recognised as having existing TDI
        const { customer: { data: { hasTdiLogin = true } = {} } = {}, updateCart: { data: { cartTotalPrice = [] } = {} } = {} } = state.app.appData;
        if (cartTotalPrice.length !== 0) {
            const { price: { dutyFreeAmount: { value = '' } = {} } = {}, priceBeforeDiscount: { dutyFreeAmount: { value: priceBeforeDiscountVal = '' } = {} } = {} } = cartTotalPrice[0];
            actualAmount = value;
            priceBeforeDiscount = priceBeforeDiscountVal;
        }
        const newOfferSelected = state.offerDetails.selectedOffer ? state.offerDetails.selectedOffer : {};
        const { yourContactDetailsForm: { values: { emailAddress: emailAddressUnAuth } = {} } = {} } = state.form || {};
        const { portingNumber = '' } = state.welcome;
        const { starterCredit, msisdn } = getCustomerState();
        const { activationDataDetails: { isAutoRechargeSuccessful } = {} } = state.reviewDetails.activationData || {};
        // const { loggedInCustomerData: { anonymous = true } = {}, appData: { customer: { data: { stepUpSuccessful = false } = {} } = {} } = {} } = state.app;
        const serviceCount = this.props.appData.customerInfo.serviceCount;
        const businessDetails = this.props.app.loggedInCustomerData && this.props.app.loggedInCustomerData.businessDetails;
        const selectedBusinessDetails = (businessDetails && businessDetails.find(item => item.accountNumber === this.props.selectedBusiness)) || {};
        const emailAddressAuth = this.props.app.loggedInCustomerData?.contactEmail;
        const userEmail = loggedIn ? emailAddressAuth : emailAddressUnAuth;
        // Get confirmation page locale
        const {
            title: { esimTitle, activationTitle, portingTitle },
            porting: { esimPorting, portingSimHeader, portingSimContent },
            getNewNumber: { esimTitleMessage, numSimHeader, numSimContent },
            common: {subTitle}
        } = ACTIVATION_GUIDE_CONSTANTS;

        // Dynamic contents for esim 'porting/getNewNumber' and Physical sim 'porting/getNewNumber'
        const serviceNumber = isPortingFlow ? portingNumber : msisdn;
        let ConfirmHeader = isEsimActivation? esimTitle : activationTitle;
        let titleMessage = isEsimActivation ? esimTitleMessage : subTitle;
        let simHeader;
        let simContent;
        if (isPortingFlow) {
            ConfirmHeader = isEsimActivation ? esimTitle : portingTitle;
            titleMessage = isEsimActivation ? esimPorting : subTitle;
            if (!isEsimActivation) {
                simHeader = portingSimHeader;
                simContent = portingSimContent;
            }
        } else if (!isEsimActivation) {
            simHeader = numSimHeader;
            simContent = numSimContent;
        }

        const autoRechargeCardProps = {
            loggedIn,
            hasTdiLogin,
            newOfferSelected,
            actualAmount,
            starterCredit,
            priceBeforeDiscount
        };

        if (isAutoRechargeSuccessful === false) {
            addDataLayerEventInfo('error', 'auto recharge module', '', 'Auto recharge setup unsuccessful');
            if (!hasTdiLogin) {
                addDataLayerEventInfo('impression', 'auto recharge module', 'fail', 'Auto recharge setup unsuccessful - New TDI');
            } else {
                addDataLayerEventInfo('impression', 'auto recharge module', 'fail', 'Auto recharge setup unsuccessful - Existing TDI');
            }
        }

        const pageReadyToShow = !isEsimActivation || !isProcessingProfile;
        if (!pageReadyToShow) return;

        const isLastServiceActivation = (!loggedIn && serviceCount === 34) || (loggedIn && selectedBusinessDetails.lastService);

        const Wrapper = ({ children }) =>
            <div className="container confirm-block">
                <GlobalBanner onPage="success" className="infobanner-success" />
                {children}
            </div>

        if (hasEsimProfileError) {
            return (
                <Wrapper>
                    {this.renderProfileErrorGuide(serviceNumber, starterCredit, actualAmount, newOfferSelected, skipRecharge)}
                </Wrapper>
            );
        }

        return (
            <Wrapper>

                <TitleSection header={ConfirmHeader} title={titleMessage}>
                    {isEsimActivation && <SpinningButton
                        id="Download"
                        stylingClass="esim-download-btn"
                        variant="HighEmphasis"
                        buttonText={'Download eSIM profile'}
                        onSubmit={() => this.profileDownloadRedirect()} />}
                </TitleSection>

                <div className="row ag-content">

                    <div className="col-md-6">
                        <div className="ag-content__left">
                            {isLastServiceActivation && this.renderLastServiceAlert()}
                            <div className={`service-activation-wrapper ${isEsimActivation ? "change-order" : ""}`}>
                                {this.renderServiceDetails(serviceNumber, starterCredit, actualAmount, newOfferSelected, skipRecharge)}
                                {this.renderActivationInProgress({isPortingFlow})}
                            </div>
                            {!isEsimActivation && this.renderFinalSteps({ hasTdiLogin, loggedIn, simContent, simHeader, userEmail })}
                            {this.renderARMessage(isAutoRechargeSuccessful, autoRechargeCardProps)}
                            {!isEsimActivation && this.renderDownloadContent()}
                            {this.renderDirectoryListing()}
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="ag-content__right">
                            {!isEsimActivation ? (
                                this.renderServiceDetailsDesktop(serviceNumber)
                            ) : (
                                <div className='plan-details-esim'>{this.renderServiceDetails(serviceNumber, starterCredit, actualAmount, newOfferSelected, skipRecharge)}</div>
                            )}
                        </div>
                    </div>

                </div>

            </Wrapper>
        );
    }

    renderLastServiceAlert = () => (
        <MessageSection
            developmentUrl={ableSpriteSheet}
            variant="Information"
            description="You've almost reached the maximum number of Pre-Paid services on your account. This will be the last service you can activate." />
    )

    getCardDetails(serviceNumber, starterCredit, actualAmount, newOfferSelected, skipRecharge) {
        return <OfferCard {...this.props} plan={newOfferSelected} msisdn={serviceNumber} starterCredit={starterCredit} price={actualAmount} confirm={'true'} skipRecharge={skipRecharge} />;
    }

    renderServiceDetails(serviceNumber, starterCredit, actualAmount, newOfferSelected, skipRecharge) {
        return (
            <OfferCard
                {...this.props}
                plan={newOfferSelected}
                msisdn={serviceNumber}
                starterCredit={starterCredit}
                price={actualAmount}
                confirm={'true'}
                skipRecharge={skipRecharge} />
        );
    }

    renderServiceDetailsDesktop(serviceNumber) {
        return (
            <div className="ag-service-details">
                <div className="ag-service-details--top">
                    <TextStyle alias="LabelA1">Your service details</TextStyle>
                    <TextStyle alias="Base" colour="Subtle">{serviceNumber}</TextStyle>
                </div>
                <Divider />
                <div className="ag-service-details--bottom">
                    <TextStyle alias="LabelA1">Do it all in one place with the My Boost Mobile app:</TextStyle>
                    <ul className="ag-checklist">
                        <TextStyle element="li" alias="Base" className="ag-checklist--item">
                            <span><Icon icon="Tick" aria-hidden developmentUrl={ableSpriteSheet} /></span>
                            Recharge and manage your auto recharge
                        </TextStyle>
                        <TextStyle element="li" alias="Base" className="ag-checklist--item">
                            <span><Icon icon="Tick" aria-hidden developmentUrl={ableSpriteSheet} /></span>
                            Check your balance and plan details
                        </TextStyle>
                        <TextStyle element="li" alias="Base" className="ag-checklist--item">
                            <span><Icon icon="Tick" aria-hidden developmentUrl={ableSpriteSheet} /></span>
                            Track your usage and purchase extras
                        </TextStyle>
                        <ActionButton href="#download-app" element="a" variant="LowEmphasis" label="Download the My Boost Mobile app" />
                    </ul>
                </div>
            </div>
        );
    }

    renderActivationInProgress = ({ isPortingFlow }) => (
        <div className="ag-inprogress">
            <Picto className="able-boost-picto"><Clock56 /></Picto>
            <TextStyle alias="HeadingC">{isPortingFlow ? "Transfer" : "Activation"} in progress</TextStyle>
            <TextStyle alias="Base">This typically takes{isPortingFlow ? ' up to 4 business ': ' 4 '}hours, but most services are up and running before that. You'll receive an email when your service is ready to use.{isPortingFlow ? " If we need more information, we'll be in touch." : ''}</TextStyle>
        </div>
    )

    renderFinalSteps = ({ loggedIn, hasTdiLogin, simHeader, simContent, userEmail }) => {
        if (loggedIn || hasTdiLogin) {
            return this.renderRegistrationContent(simHeader, simContent, loggedIn, hasTdiLogin, userEmail);
        }
        return this.renderUnauthContent(simHeader, simContent, userEmail);
    }

    renderARMessage = (isAutoRechargeSuccessful, autoRechargeCardProps) => {
        if (isAutoRechargeSuccessful) {
            return <AutoRechargeEnabledCard {...autoRechargeCardProps} />;
        }
        else if (isAutoRechargeSuccessful === false) {
            return (
                <div id="auto-recharge-fail">
                    <MessageSection
                        developmentUrl={ableSpriteSheet}
                        variant="Error"
                        description={'Please try again later on the My Boost Mobile app.'}
                        titleText={'Auto recharge setup unsuccessful'}
                        titleElement="h2"
                    />
                </div>
            );
        }
        return null;
    }

    renderRegistrationContent(simHeader, simContent, loggedIn, hasTdiLogin, userEmail) {
        const { common: {setupAccountHeader, setupAccountContent, manageServiceHeader, manageServiceContent} } = ACTIVATION_GUIDE_CONSTANTS;    
        return (
            <div className="ag-finalsteps">
                <TextStyle element="h2" alias="HeadingB">Let's get started</TextStyle>
                {hasTdiLogin && !loggedIn && <div className="ag-finalsteps--step">
                    <img src={boostProfile} alt="" />
                    <TextStyle element="h3" alias="HeadingC">{setupAccountHeader}</TextStyle>
                    <TextStyle element="p" alias="Base">{setupAccountContent}</TextStyle>
                    <ActionButton element="a" href={SIGN_IN} label="Sign in" variant="LowEmphasis" />
                </div>}

                <div className="ag-finalsteps--step">
                    <img src={simCard} alt="" />
                    <TextStyle element="h3" alias="HeadingC">{simHeader}</TextStyle>
                    <TextStyle element="p" alias="Base">{simContent}</TextStyle>
                </div>
                {loggedIn && <div className="ag-finalsteps--step">
                    <img src={boostProfile} alt="" />
                    <TextStyle element="h3" alias="HeadingC">{manageServiceHeader}</TextStyle>
                    <TextStyle element="p" alias="Base">Use your Boost ID {userEmail} {manageServiceContent}</TextStyle>
                    <ActionButton element="a" href={SIGN_IN} label="Sign in" variant="LowEmphasis" />
                </div>}
            </div>
        );
    }

    renderUnauthContent(simHeader, simContent, userEmail) {
        const { common: {detailMessage} } = ACTIVATION_GUIDE_CONSTANTS;
        return (
            <div className="ag-finalsteps">
                <TextStyle element="h2" alias="HeadingB">Let's get started</TextStyle>
                <div className="ag-finalsteps--step">
                    <img src={boostProfile} alt="" />
                    <TextStyle element="h3" alias="HeadingC">Set up your account</TextStyle>
                    <TextStyle element="p" alias="Base">
                        {'Your Boost ID is '}
                        {userEmail}
                        {detailMessage}
                    </TextStyle>
                </div>

                <div className="ag-finalsteps--step">
                    <img src={simCard} alt="" />
                    <TextStyle element="h3" alias="HeadingC">{simHeader}</TextStyle>
                    <TextStyle element="p" alias="Base">{simContent}</TextStyle>
                </div>
            </div>
        );
    }

    renderDownloadContent() {
        let downloadUrl = '';
        let downloadButton = 'Get the app';
        if (window.navigator.userAgent.indexOf('Mac') !== -1 && window.navigator.userAgent.indexOf('Mobile') !== -1) {
            downloadUrl = DOWNLOAD_APP_IOS;
        } else if (window.navigator.userAgent.indexOf('Android') !== -1 && window.navigator.userAgent.indexOf('Mobile') !== -1) {
            downloadUrl = DOWNLOAD_APP_ANDROID;
        } else {
            downloadUrl = GET_THE_APP;
        }
        return (
            <div className="download-card" id="download-app">
                <div className="download-content">
                    <div className="download-content--top">
                        <img src={boostAppIcon} alt="" />
                        <TextStyle alias="HeadingC">Download the My Boost Mobile app</TextStyle>
                    </div>
                    <div className="download-content--image">
                        <img className="boost-image" src={boostAppImage} alt="" />
                    </div>

                    <div role="list" className="ag-checklist">
                        <TextStyle element="p" role="listitem" alias="Base" className="ag-checklist--item">
                            <span><Icon icon="Tick" aria-hidden developmentUrl={ableSpriteSheet} /></span>
                            Recharge and manage your auto recharge
                        </TextStyle>
                        <TextStyle element="p" role="listitem" alias="Base" className="ag-checklist--item">
                            <span><Icon icon="Tick" aria-hidden developmentUrl={ableSpriteSheet} /></span>
                            Check your balance and plan details
                        </TextStyle>
                        <TextStyle element="p" role="listitem" alias="Base" className="ag-checklist--item">
                            <span><Icon icon="Tick" aria-hidden developmentUrl={ableSpriteSheet} /></span>
                            Track your usage and purchase extras
                        </TextStyle>
                    </div>
                    <ActionButton
                        variant="MediumEmphasis"
                        label={downloadButton}
                        element="a"
                        href={downloadUrl}
                        className="w-100 downlad-app-btn boost-able-button" />
                </div>
            </div>
        );
    }

    renderDirectoryListing() {
        const { directoryListing: { header, content} } = ACTIVATION_GUIDE_CONSTANTS;
        // eslint-disable-next-line max-len
        return (
            <div id="directory-listing">
                <MessageSection
                    developmentUrl={ableSpriteSheet}
                    variant="Information"
                    description={content}
                    titleText={header}
                    titleElement="h2"
                />
            </div>
        );
    }

    profileDownloadRedirect() {
        addDataLayerEventInfo('click', 'clickTrack', 'buttonClick', 'eSIM download');
        const state = store.getState();
        const {
            esimData: { activationCode, deepLinks = {} },
            msisdn
        } = state.app.appData;
        const regex = /^\+61|^61/;
        const serviceId = msisdn.replace(regex, 0);
        const redirectUrl = `${deepLinks.download}?activationCode=${activationCode}&serviceId=${serviceId}`;
        window.sessionStorage.removeItem('source');
        window.sessionStorage.removeItem('esimFlow');
        window.location.href = redirectUrl;
    }

    renderProfileErrorGuide(serviceNumber, starterCredit, actualAmount, newOfferSelected, skipRecharge) {
        const {
            esimProfileError: {
                esimProfileErrortitle,
                esimProfileErrorTitleMessage,
                step1,
                step1Message,
                step2,
                step2Message,
                step3,
                step3Message,
                step4,
                step4Message,
                step5,
                step5Message,
                step6,
                step6Message
            }
        } = ACTIVATION_GUIDE_CONSTANTS;

        return (
            <div className="row m-0 esim-profile-error-guide w-100">

                <div className="col-md-6 col-sm-12">
                    <div className="error-guide-section">
                        <Spacing bottom="spacing5x" topVLG="spacing2x" topVMD="spacing2x" topVSM="spacing2x">
                            <TextStyle element="h1" alias="HeadingA">
                                {esimProfileErrortitle}
                            </TextStyle>
                        </Spacing>
                        <Spacing bottom="spacing4x">
                            <TextStyle alias="Base">
                                {esimProfileErrorTitleMessage}
                            </TextStyle>
                        </Spacing>

                        <TextStyle alias="HeadingC">
                            {step1}
                        </TextStyle>
                        <Spacing top="spacing1x" bottom="spacing4x">
                            <TextStyle alias="Base">
                                {step1Message}
                            </TextStyle>
                        </Spacing>

                        <TextStyle alias="HeadingC">
                            {step2}
                        </TextStyle>
                        <Spacing top="spacing1x" bottom="spacing2x">
                            <TextStyle alias="Base">
                                {step2Message}
                            </TextStyle>
                        </Spacing>
                        <Spacing bottom="spacing4x">
                            <div className="esim-error-step-image">
                                <img alt="" src={step2image} />
                            </div>
                        </Spacing>

                        <TextStyle alias="HeadingC">
                            {step3}
                        </TextStyle>
                        <Spacing top="spacing1x" bottom="spacing2x">
                            <TextStyle alias="Base">
                                {step3Message}
                            </TextStyle>
                        </Spacing>
                        <Spacing bottom="spacing4x">
                            <div className="esim-error-step-image">
                                <img alt="" src={step3image} />
                            </div>
                        </Spacing>

                        <TextStyle alias="HeadingC">
                            {step4}
                        </TextStyle>
                        <Spacing top="spacing1x" bottom="spacing4x">
                            <TextStyle alias="Base">
                                {step4Message}
                            </TextStyle>
                        </Spacing>

                        <TextStyle alias="HeadingC">
                            {step5}
                        </TextStyle>
                        <Spacing top="spacing1x" bottom="spacing4x">
                            <TextStyle alias="Base">
                                {step5Message}
                            </TextStyle>
                        </Spacing>

                        <TextStyle alias="HeadingC">
                            {step6}
                        </TextStyle>
                        <Spacing top="spacing1x" bottom="spacing15x" bottomVXS="spacing7x">
                            <TextStyle alias="Base">
                                {step6Message}
                            </TextStyle>
                        </Spacing>

                    </div>
                </div>

                <div className="col-md-6 col-sm-12">
                    <div className="error-guide-section error-guide-section--right">
                        <Spacing topVXS="spacing3x" bottom="spacing4x" bottomVXS="spacing5x" topVLG="spacing2x" topVMD="spacing2x" topVSM="spacing2x">
                            <TextStyle alias="HeadingC">
                                Recharge details
                            </TextStyle>
                        </Spacing>
                        {this.getCardDetails(serviceNumber, starterCredit, actualAmount, newOfferSelected, skipRecharge)}

                        <Spacing top="spacing4x" topVXS="spacing5x" bottom="spacing10x">
                            {this.renderDirectoryListing()}
                        </Spacing>
                    </div>
                </div>
            </div>
        );
    }
}

function TitleSection({ header, title, children }) {
    return (
        <div className="row ag-title-section">
            <div className="col-md-7">
                <Picto className="able-boost-picto">
                    <Success104 />
                </Picto>
                <TextStyle element="h1" alias="HeadingB" tabIndex="-1">
                    {header}
                </TextStyle>
                <TextStyle alias="Base">{title}</TextStyle>
                {children}
            </div>
        </div>
    );
}

export default ActivationGuide;
